// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyATe-x2ewTzxKKvA9XuIiw3_VKJf2idseU",
  authDomain: "yoga-life-26336.firebaseapp.com",
  projectId: "yoga-life-26336",
  storageBucket: "yoga-life-26336.appspot.com",
  messagingSenderId: "970745916122",
  appId: "1:970745916122:web:2cbf2f27eab917248113e3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth=getAuth(app)
export{app,auth}